import ErrorIcon from '@mui/icons-material/ErrorOutline';
import InfoIcon from '@mui/icons-material/InfoOutlined';
import SuccessIcon from '@mui/icons-material/TaskAltOutlined';
import WarningIcon from '@mui/icons-material/WarningAmberRounded';
import { MessageColor } from '@mui/material';
import * as React from 'react';

export const messageIcons: Record<MessageColor, React.ReactNode | null> = {
    secondary: null,
    info: <InfoIcon color="info" />,
    warning: <WarningIcon color="warning" />,
    success: <SuccessIcon color="success" />,
    error: <ErrorIcon color="error" />,
} as const;
